module.exports = __webpack_public_path__ + "fonts/HKGrotesk-SemiBold.5077391.otf";